import { GraphQLString, GraphQLNonNull, GraphQLInputObjectType, GraphQLFloat } from 'graphql';

import ResponseTypeEnum from './enums/responseTypeEnum.gql';

const AnswerType = new GraphQLInputObjectType({
  name: 'AnswersType',
  description: 'Array of answer for all questions',
  fields: () => ({
    questionId: {
      type: new GraphQLNonNull(GraphQLString)
    },
    response: {
      type: new GraphQLNonNull(GraphQLString)
    },
    answerEvaluation: {
      type: new GraphQLNonNull(GraphQLString)
    },
    timeStamp: {
      type: new GraphQLNonNull(GraphQLString)
    },
    responseType: {
      type: new GraphQLNonNull(ResponseTypeEnum)
    },
    rawScore: {
      type: new GraphQLNonNull(GraphQLFloat)
    },
    progressMeasure: {
      type: new GraphQLNonNull(GraphQLFloat)
    }
  })
});

window[AnswerType.name + 'GQLType'] = AnswerType;

export default AnswerType;
